



















import FooterLogo from "~/components/FooterLogo.vue";
import Vue from "vue";

export default Vue.extend({
  components: {
    FooterLogo
  },
  data: () => ({
    expandCard: false,
    expandLogo: false
  }),
  mounted() {
    // Wait before opening card
    setInterval(() => {
      this.expandCard = true;
    }, 300);

    // Wait before showing qurit logo
    setInterval(() => {
      this.expandLogo = true;
    }, 435);
  }
})
